module.exports = __webpack_public_path__ + "public/files/img/import-excel-example.2f6a3527.png";